import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-propertyregister-form',
  templateUrl: './propertyregister-form.component.html',
  styleUrls: ['./propertyregister-form.component.css']
})
export class PropertyregisterFormComponent implements OnInit {
  title="Property Register";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/property-register/propertyregister-form/propertyregister-form.component.ts